import { cachedHttp } from "./httpService";

const apiEndPoint = "/alertchannels/";

function getAlertChannels() {
  return cachedHttp.get(apiEndPoint);
}

export default getAlertChannels;
